import { useOutletContext } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { PerformanceReviewOverviewPersonalResultsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { PersonalResults } from 'modules/performance_process/components/review/show/PersonalResults'
import { TasksContainer } from 'modules/performance_process/components/review/show/Tasks'
import { PeerAssignmentTask } from 'modules/performance_process/components/review/show/Tasks/PeerAssignment'
import { PendingAgreementsTask } from 'modules/performance_process/components/review/show/Tasks/PendingAgreements'
import { PendingEvaluationsTask } from 'modules/performance_process/components/review/show/Tasks/PendingEvaluations'
import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

const ReviewOverviewPersonalResultsPage = () => {
  const { reviewProcess, canOnlySeePersonalResults } =
    useOutletContext<ReviewOverviewOutletContext>()
  const { access } = useCurrentSession()

  const { data, loading } = useQuery(PerformanceReviewOverviewPersonalResultsPageDocument, {
    variables: {
      currentAccessId: access.id,
      reviewProcessId: reviewProcess.id,
    },
  })

  const currentTarget = data?.performance.currentAccessTarget?.nodes[0]

  if (loading) {
    return (
      <Box flexGrow justifyContent="center" alignItems="center">
        <Spinner />
      </Box>
    )
  }

  if (!canOnlySeePersonalResults && !currentTarget?.access) return null

  return (
    <Box flexGrow gap="s48">
      {canOnlySeePersonalResults && (
        <TasksContainer>
          <PendingEvaluationsTask />
          <PendingAgreementsTask />
          <PeerAssignmentTask />
        </TasksContainer>
      )}
      {currentTarget && (
        <PersonalResults reviewProcessTargetId={currentTarget.id} isCheckingOwnResults />
      )}
    </Box>
  )
}

export default ReviewOverviewPersonalResultsPage
